<template>
  <div class="Traincourse">
    <div class="introduce">
      <el-row class="flex-col-center">
        <el-col :span="8">
          <img src="../assets/image/course/img1.png" alt="" style="width:80%" />
        </el-col>
        <el-col :span="16">
          <h1>生涯规划咨询师课程介绍</h1>
          <p>
            生涯规划咨询师课程是针对生涯规划咨询师课体系制作的教学培训课程，由生涯规划咨询师平台制作并上传，主要用于生涯规划咨询师考生的考前知识培训，课程内容包括：5个板块（理念篇、认知篇、规划篇、储备篇、进阶篇）的课程教学，考生可通过课程的培训学习来提高自身的生涯规划能力，以此保证通过考试。生涯规划咨询师平台建议考生先学习课程，再通过模拟练习打磨知识，最后再参加正式考试，从而顺利的获得证书！
          </p>
          <el-button @click="joincourse">立即参加课程培训</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane label="课程介绍" name="first">
          <div class="introduce_top">
            <br />
            <h1 class="text-center">课程介绍</h1>
            <el-row type="flex" align="middle" :gutter="20">
              <el-col :span="8" :offset="4">
                <div class="card">
                  生涯规划咨询师课程是针对生涯规划咨询师评测体系制作的教学培训课程，由生涯规划咨询师平台邀请名师制作，主要用于生涯规划咨询师考生的考前知识培训。
                </div>
                <div class="card">
                  5个板块（理念篇、认知篇、规划篇、储备篇、进阶篇），共十二节的课程教学，考生可通过课程的培训学习来提高自身的网络教学能力，以此来保证通过考试。
                </div>
              </el-col>
              <el-col :span="8">
                <img
                  src="../assets/image/course/img2.png"
                  alt=""
                  style="width:80%"
                />
              </el-col>
            </el-row>
          </div>

          <div class="introduce">
            <div class="introduce_center">
              <h1 class="text-center">
                生涯规划咨询师<span style="color:#ff462a">核心技能</span>
              </h1>
              <br />
              <el-row type="flex" align="middle">
                <el-col :span="8" :offset="4">
                  <img
                    src="../assets/image/course/img3.png"
                    alt=""
                    style="width:80%"
                  />
                </el-col>
                <el-col :span="8" class="text-right">
                  <b class="button">知识能力</b>
                  <p>
                    需要熟悉国家的教育政策、高等教育招生制度，了解各大学的专业设置和特色等
                  </p>
                  <b class="button">沟通能力</b>
                  <p>
                    能够与学生建立良好的沟通关系，听取他们的需求和想法，
                    并对他们进行有针对性的学业及职业指导
                  </p>
                  <b class="button">心理学</b>
                  <p>
                    具有社会心理学和组织心理学、传播学的相关基础，
                    知道人群个体差距和心理差异，以便更好解决问题
                  </p>
                </el-col>
                <el-col :span="4" style="position:relative">
                  <img
                    src="../assets/image/course/img12.png"
                    alt=""
                    style="position:absolute;bottom:-140px;left:-35px"
                  />
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="introduce_feature">
            <div class="introduce">
              <h1 style="color:#fff" class="text-center">
                生涯规划咨询师课程特色
              </h1>
              <br />
              <div class="flex-row-between ">
                <div
                  class="text-center feature_container"
                  v-for="(item, i) in list"
                  :key="i"
                  :style="{
                    background: 'url(' + item.url + ')',
                    'background-repeat': 'no-repeat',
                    'background-size': '100% 100%',
                    width: '23%',
                    height: '250px',
                    display: 'inline-block',
                  }"
                >
                  <div class="feature">
                    <h3>{{ item.title }}</h3>
                    <p v-html="item.content"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="why">
            <br />
            <h1 class="text-center">
              为什么<span style="color:#ff462a">先学习课程</span>
            </h1>
            <br />
            <div class="why_con flex">
              <div class="text-center why_l" style="width:30%;">
                <b>助力您成为</b><br />
                <b>生涯规划师</b><br />
                <el-button size="mini" type="warning" plain @click="joincourse"
                  >立即参加培训课程</el-button
                >
              </div>
              <div class="why_r" style="width:70%">
                <ul>
                  <li>
                    因为生涯规划咨询师评测体系是检验学员是否已经具备了对来访者进行生涯规划指导的能力，所以评测的内容及知识比较繁多，要求学员熟练掌握知识才可通过评测。
                  </li>
                  <br />
                  <br />
                  <br />
                  <li>
                    生涯规划师平台建议学员先学习生涯规划课程和参加模拟练习后再前往正式考试。
                  </li>
                </ul>
              </div>
              <img
                class="why_bg"
                src="../assets/image/course/img10.png"
                alt=""
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="课程目录" name="second">
          <div class="table">
            <el-table
              :data="tableData"
              style="width: 100%"
              stripe
              :header-cell-style="{
                'text-align': 'center',
                background: '#fd4a29',
                color: '#fff',
              }"
            >
              <el-table-column
                prop="section"
                label="章节"
                align="center"
                width="200"
              />
              <el-table-column prop="name" label="课程名称" align="center" />
            </el-table>
            <hr />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
let _this
export default {
  data() {
    return {
      tableData: [
        {
          section: '第一讲',
          name: '生涯规划教育概述',
        },
        {
          section: '第二讲',
          name: '能力与兴趣',
        },
        {
          section: '第三讲',
          name: '生涯规划视角下如何认知性格及职业价值观',
        },
        {
          section: '第四讲',
          name: '认识大学及专业',
        },
        {
          section: '第五讲',
          name: '认识行业及职业',
        },
        {
          section: '第六讲',
          name: '认识新高考',
        },
        {
          section: '第七讲上',
          name: '如何进行高中选科',
        },
        {
          section: '第七讲下',
          name: '如何填报高考志愿',
        },
        {
          section: '第八讲',
          name: '新高考升学路径有哪些？',
        },
        {
          section: '第九讲',
          name: '强基计划整体解读',
        },
        {
          section: '第十讲',
          name: '生涯关键能力储备',
        },
        {
          section: '第十一讲',
          name: '如何培养人际能力及情绪管理与训练',
        },
        {
          section: '第十二讲',
          name: '高效的学习方法',
        },
      ],
      list: [
        {
          url: require('../assets/image/course/img8.png'),
          title: '理论体系化',
          content: '专业系统理论学习<br/>掌握生涯规划咨询师方法论',
        },
        {
          url: require('../assets/image/course/img7.png'),
          title: '实践案例化',
          content: '结合案例实操演练<br/>吸取行业先进经验',
        },
        {
          url: require('../assets/image/course/img6.png'),
          title: '讲师专业化',
          content: '国内知名生涯规划教育<br/>专家领衔专业讲师团队',
        },
        {
          url: require('../assets/image/course/img5.png'),
          title: '培训标准化',
          content: '教学方法标准化<br/>以提高培训教学效果',
        },
      ],
      activeName: 'first',
      user: {},
    }
  },
  created() {
    this.user = localStorage.getItem('wps_user')
  },
  mounted() {},

  methods: {
    joincourse(id) {
      if (this.user) {
        this.$router.push({
          path: '/course',
        })
      } else {
        this.$message.warning('您还未登录，请先登录！')
      }
    },
  },
}
</script>
<style lang="less" scoped>
h1 {
  font-size: 28px;
  font-weight: bold;
  color: #000005;
}
p {
  font-size: 14px;
  line-height: 20px;
  margin: 10px 0px 20px;
}
.Traincourse {
  width: 100%;
  min-width: 1100px;
  color: #666;
  .introduce {
    width: 60%;
    margin: 0px auto;
    padding: 30px 0px;
    img {
      width: 100%;
    }
    .el-button {
      padding: 10px;
      background: #fd4a29;
      border-radius: 4px;
      color: #ffffff;
      border: none;
    }
  }
  .tabs {
    /deep/.el-tabs__nav-scroll {
      max-width: 800px;
      margin: 0px auto;
      .el-tabs__item {
        font-size: 22px;
        font-weight: 500;
        color: #000005;
        line-height: 20px;
      }
    }
    /deep/.el-tabs__nav-wrap::after {
      height: 0px !important;
    }
    /deep/.el-tabs__active-bar {
      height: 3px;
      background: #fd4a29;
    }
  }

  .table {
    padding: 40px 0;
    width: 60%;
    margin: 0 auto;
    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background: #fcf9f6;
      border: none;
    }
  }
}

hr {
  background: #fe846e;
  height: 5px;
  border: none;
}
.introduce_top {
  background: url('../assets/image/course/img11.png');
  background-size: 100% 100%;
  height: 400px;
}
.card {
  background-color: #fff;
  padding: 20px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
  margin: 25px;
  border-radius: 10px;
}
.button {
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
  display: inline-block;
  padding: 5px 15px;
  border-radius: 6px;
  color: #fd4a29;
  font-size: 14px;
}
.introduce_feature {
  background: linear-gradient(to right, #ff9b5f 0%, #ff7a54 100%);
  padding: 20px;
}
.feature_container {
  position: relative;
  h3 {
    color: #fd4a29;
  }
  p {
    font-size: 12px;
  }
}
.feature {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
}
.why {
  padding: 20px 0 50px 0;
}
.why_con {
  width: 60%;
  margin: 0 auto;
  position: relative;
}
.why_con div:nth-child(1) {
  background-color: #fd4a29;
  color: #fff;
  font-size: 24px;
}
.why_con div:nth-child(1) {
  background-color: #fd4a29;
  color: #fff;
  font-size: 24px;
}
ul li::marker {
  background-color: #fd4a29;
}
.why_l {
  padding-top: 16px;
}
.why_r {
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.03);
  padding: 20px;
  padding-left: 40px;
  font-size: 14px;
}
.why_bg {
  position: absolute;
  right: -150px;
  bottom: -140px;
  width: 260px;
}
</style>
